import { firestore, firebaseAuth } from '../plugins/firebase'

const authService = {
  login: async (user) => {
    const response = await firebaseAuth.signInWithEmailAndPassword(user.email, user.password)

    if (response) {
      const userQuery = await firestore
        .collection('users')
        .where('email', '==', user.email)
      const userSnapshot = await userQuery.get()
      const userDocument = userSnapshot.docs[0]
      const userData = await userDocument.data()
      const userObj = {
        id: userDocument.id,
        ...userData
      }

      return userObj
    }
  },

  logout: async () => {
    const response = await firebaseAuth.signOut()
    return response
  },

  register: async user => {
    const response = await firebaseAuth.createUserWithEmailAndPassword(user.email, user.password)
    return response
  },

  refresh: async () => {
    if (firebaseAuth.currentUser) {
      const response = await firebaseAuth.currentUser.getIdToken(true)
      return response
    }
  },

  update: (userId, userProfile) => {
    return fetch(`/user/${userId}/profile`, {
      method: 'PUT',
      body: userProfile
    })
  },

  formatUserObject: (response) => {
    const { email, refreshToken, uid } = response.user
    return { email, refreshToken, uid }
  },

  authWithFacebook: async () => {
    const provider = new firebaseAuth.FacebookAuthProvider()
    firebaseAuth.useDeviceLanguage()
    provider.addScope('user_birthday')
    provider.addScope('instagram_basic')
    provider.addScope('manage_pages')
    provider.addScope('pages_show_list')

    firebaseAuth.signInWithPopup(provider).then(function (result) {
      var token = result.credential.accessToken
      var user = result.user

      console.log(user, token)
    }).catch(function (error) {
      // Handle Errors here.
      var errorCode = error.code
      var errorMessage = error.message
      // The email of the user's account used.
      var email = error.email
      // The firebase.firebaseAuth.AuthCredential type that was used.
      var credential = error.credential

      console.log(errorCode, errorMessage, email, credential)
    })
  }
}

export { authService }
